import { render } from "./EditCollaboratorsIcon.vue?vue&type=template&id=75574a39"
import script from "./EditCollaboratorsIcon.vue?vue&type=script&lang=js"
export * from "./EditCollaboratorsIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__